import * as React from 'react';
import { useMediaQuery } from '@mui/material';
import ParticipanteSolicitudesMovil from './ParticipanteSolicitudesMovil';
import ParticipanteSolicitudes from './ParticipanteSolicitudes';

function VistaParticipanteSolicitudes() {
    const isMobile = useMediaQuery('(max-width:800px)'); // Puedes ajustar el valor según tu criterio de ancho para dispositivos móviles

    return (
        <>
            {isMobile ? (
                <ParticipanteSolicitudesMovil />
            ) : (
                <ParticipanteSolicitudes />
            )}
        </>
    );
}

export default VistaParticipanteSolicitudes;